export default __webpack_public_path__ + "static/media/unstablemind.26196c61.png";